import { useQueryClient } from '@tanstack/react-query'
import type { QueryKey } from '@tanstack/react-query'

export const useQueryData = <T>(queryKey: QueryKey): T | undefined => {
  const queryClient = useQueryClient()

  return queryClient.getQueryData<T>(queryKey)
}
